/**
 * created by li si yi
 * 媒体筛选组件
 */
import React, {Component} from 'react';
import {Button, Input, Select} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import moment from "moment";
import '../publishStatistics.css'

const {Option} = Select;

class MediaSelect extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            mediaList: [],// 媒体数据
            mediaName: "",
            mediaIds: [],// 媒体ID
        }
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.resetMedia !== this.props?.resetMedia) {
            this.state.mediaIds = nextProps.resetMedia;// 重置
            this.setState({})
        }
    }

    // 数据
    getMediaList = (res) => {
        this.state.mediaList = res;
        this.setState({}, () => {
            this.state.mediaIds = this.state.mediaIds.filter(checkItem => res.some(item => item.id === checkItem));
            if (this.state.mediaIds && this.state.mediaIds.length > 0 && !this.props.statisticsLinkTable) {
                this.handleChangeMedia(this.state.mediaIds)
            }
            this.setState({})
        })
    };

    render() {
        if (this.props.statisticsTable) {
            this.state.mediaList = JSON.parse(JSON.stringify(this.props?.mediaList));
        }
        let {size, disabled, id, placeholder, style, value, maxTagCount} = this.props;
        return (
            <>
                <Select
                    className={'select_media select-without-tag'}
                    mode="multiple"
                    style={style ? style : {width: '240px', marginRight: 20}}
                    placeholder={placeholder ? placeholder : "请选择媒体"}
                    value={this.state.mediaIds == "" || value == "" ? undefined : this.state.mediaIds}
                    onChange={(value, e) => {
                        this.handleChangeMedia(value, e)
                    }}
                    optionFilterProp={"children"}
                    size={size}
                    disabled={disabled ? disabled : this.state.mediaList.length <= 0}
                    id={id}
                    maxTagCount={maxTagCount}
                >
                    {this.state.mediaList && this.state.mediaList.map((item, index) => {
                        return (
                            <Option key={item.id}>{item.name}</Option>
                        )
                    })}
                </Select>
                <style>
                    {
                        // `.select_media .ant-select-search--inline .ant-select-search__field__wrap {width:0;height:0}`
                        `
                        .select_media .ant-select-selection--multiple .ant-select-selection__choice__content {max-width:80px}
                        `
                    }
                </style>
            </>

        );
    };

    // 媒体改变
    handleChangeMedia(value, e) {
        // console.log("==============================",value, e);
        this.state.mediaIds = value;
        this.props.checkMedia && this.props.checkMedia(value);
        this.setState({})
    }
}

export default MediaSelect;